import { render, staticRenderFns } from "./signed.vue?vue&type=template&id=484a7595"
import script from "./signed.vue?vue&type=script&lang=ts"
export * from "./signed.vue?vue&type=script&lang=ts"
import style0 from "./signed.vue?vue&type=style&index=0&id=484a7595&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports